import Icon from '@ant-design/icons';
import type { ComponentProps } from 'react';

/** Core Icon Library — icon/status-warning (Third Eye style card, 24px grid, solid fill). */
const StatusWarningSvg = () => (
  <svg viewBox='0 0 24 24' width='1em' height='1em' fill='none' aria-hidden='true'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.401 3.00299C10.556 1.00299 13.444 1.00299 14.598 3.00299L21.953 15.751C23.107 17.751 21.663 20.251 19.354 20.251H4.645C2.336 20.251 0.892995 17.751 2.047 15.751L9.4 3.00299H9.401ZM12 8.24999C12.1989 8.24999 12.3897 8.32901 12.5303 8.46966C12.671 8.61031 12.75 8.80108 12.75 8.99999V12.75C12.75 12.9489 12.671 13.1397 12.5303 13.2803C12.3897 13.421 12.1989 13.5 12 13.5C11.8011 13.5 11.6103 13.421 11.4697 13.2803C11.329 13.1397 11.25 12.9489 11.25 12.75V8.99999C11.25 8.80108 11.329 8.61031 11.4697 8.46966C11.6103 8.32901 11.8011 8.24999 12 8.24999ZM12 16.5C12.1989 16.5 12.3897 16.421 12.5303 16.2803C12.671 16.1397 12.75 15.9489 12.75 15.75C12.75 15.5511 12.671 15.3603 12.5303 15.2197C12.3897 15.079 12.1989 15 12 15C11.8011 15 11.6103 15.079 11.4697 15.2197C11.329 15.3603 11.25 15.5511 11.25 15.75C11.25 15.9489 11.329 16.1397 11.4697 16.2803C11.6103 16.421 11.8011 16.5 12 16.5Z'
      fill='currentColor'
    />
  </svg>
);

export const StatusWarningIcon = (props: Partial<ComponentProps<typeof Icon>>) => (
  <Icon aria-label='status-warning' component={StatusWarningSvg} {...props} />
);
